import { getActiveFormUses, INGESTION_POINT_FORM_USES, type IngestionPointFormUse } from "../data.ingestion.const";
import type { IngestionPoint } from "../data.ingestion.service";

export function shouldIncludeFormByEnabled(point: IngestionPoint, excludeDisabled: boolean): boolean {
    if (!excludeDisabled) {
        return true;
    }
    return point.enabled === true;
}

export function filterIngestionPointsForList(points: IngestionPoint[], excludeDisabled: boolean): IngestionPoint[] {
    if (!excludeDisabled) {
        return points;
    }
    return points.filter((point) => shouldIncludeFormByEnabled(point, true));
}

export function formatFormUseColumnText(use?: IngestionPointFormUse): string {
    return getActiveFormUses(use)
        .map((useKey) => INGESTION_POINT_FORM_USES[useKey])
        .join(", ");
}

export function getDirectWorkflowDisplayName(
    workflowId: number | undefined,
    workflowNameById: ReadonlyMap<number, string | undefined>,
): string {
    if (!workflowId) {
        return "";
    }
    return workflowNameById.get(workflowId) ?? `Workflow #${workflowId}`;
}

export function buildWorkflowNameById(
    workflows: ReadonlyArray<{ workflowProcessId?: number; workflowProcessName?: string }>,
): Map<number, string | undefined> {
    const workflowNameById = new Map<number, string | undefined>();
    for (const workflow of workflows) {
        if (workflow.workflowProcessId != null) {
            workflowNameById.set(workflow.workflowProcessId, workflow.workflowProcessName);
        }
    }
    return workflowNameById;
}
